import { ExternalLink, Gift, Star, Award } from 'lucide-react';

const OffersSection = () => {
  const offers = [
    {
      id: 1,
      name: 'Placard',
      url: 'https://www.placard.pt',
      bonus: 'Welcome Bonus: 100% + 30 Free Spins',
      icon: Gift,
      color: 'from-pink-500 to-pink-600',
      bgColor: 'bg-pink-100'
    },
    {
      id: 2,
      name: '888',
      url: 'https://www.888.pt',
      bonus: 'Welcome Bonus: Up to £1000',
      icon: Star,
      color: 'from-green-500 to-green-600',
      bgColor: 'bg-green-100'
    },
    {
      id: 3,
      name: 'Betano',
      url: 'https://www.betano.pt',
      bonus: '100% up to £60 + £10 Free Bet',
      icon: Award,
      color: 'from-purple-500 to-pink-500',
      bgColor: 'bg-purple-100'
    }
  ];

  return (
    <section id="offers" className="py-20 px-4">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-pink-600 to-green-600 bg-clip-text text-transparent">
            Exclusive Casino Offers
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            Unlock the best welcome bonuses and promotions from the UK's most trusted casino operators
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {offers.map((offer, index) => {
            const Icon = offer.icon;
            const isVertical = index === 1;
            
            return (
              <div
                key={offer.id}
                className={`glass-strong rounded-3xl overflow-hidden transform hover:scale-105 transition-all duration-300 ${
                  isVertical ? 'md:row-span-2' : ''
                }`}
              >
                {/* Casino Image */}
                <div className={`h-48 ${offer.bgColor} relative`} style={{ backgroundImage: `url("/images/${offer.id === 1 ? 'aidan-howe-xrR-Kr2zppo-unsplash.jpg' : offer.id === 2 ? 'aldric-rivat-CltI5xgDAs0-unsplash.jpg' : 'amol-tyagi-7dkLbNE6ycI-unsplash.jpg'}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="flex items-center justify-between">
                      <Icon className={`w-10 h-10 text-white bg-gradient-to-r ${offer.color} p-2 rounded-full`} />
                      <div className="glass px-4 py-2 rounded-full">
                        <span className="text-white font-bold text-lg">{offer.name}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`p-6 ${isVertical ? 'flex flex-col justify-between h-auto' : ''}`}>
                  <div className="mb-4">
                    <h3 className="text-2xl font-bold text-gray-800 mb-3">{offer.name}</h3>
                    <p className="text-gray-600 leading-relaxed">{offer.bonus}</p>
                  </div>
                  
                  <a
                    href={offer.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow sponsored"
                    className={`inline-flex items-center justify-center space-x-2 w-full px-6 py-4 bg-gradient-to-r ${offer.color} text-white font-semibold rounded-xl hover:shadow-xl transition-all duration-300 transform hover:scale-105`}
                  >
                    <span>Claim at {offer.name}</span>
                    <ExternalLink className="w-5 h-5" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OffersSection;

